import { IConComponents } from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/iconComponents.type';
import React from 'react';

const Wages: React.FC<IConComponents> = ({
  fill,
  stroke,
  height = '42',
  width = '42',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="20.9961" r="21" fill={fill} />
      <path
        d="M28.3009 16.9161V22.0661C28.3009 25.1461 26.5409 26.4661 23.9009 26.4661H15.1109C14.6609 26.4661 14.2309 26.4261 13.8309 26.3361C13.5809 26.2961 13.3409 26.2261 13.1209 26.1461C11.6209 25.5861 10.7109 24.2861 10.7109 22.0661V16.9161C10.7109 13.8361 12.4709 12.5161 15.1109 12.5161H23.9009C26.1409 12.5161 27.7509 13.4661 28.1809 15.6361C28.2509 16.0361 28.3009 16.4461 28.3009 16.9161Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.302 19.9162V25.0662C31.302 28.1462 29.542 29.4662 26.902 29.4662H18.112C17.372 29.4662 16.702 29.3662 16.122 29.1462C14.932 28.7062 14.122 27.7962 13.832 26.3362C14.232 26.4262 14.662 26.4662 15.112 26.4662H23.902C26.542 26.4662 28.302 25.1462 28.302 22.0662V16.9162C28.302 16.4462 28.262 16.0262 28.182 15.6362C30.082 16.0362 31.302 17.3762 31.302 19.9162Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4994 22.136C20.9574 22.136 22.1394 20.954 22.1394 19.496C22.1394 18.0379 20.9574 16.856 19.4994 16.856C18.0414 16.856 16.8594 18.0379 16.8594 19.496C16.8594 20.954 18.0414 22.136 19.4994 22.136Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7812 17.2959V21.6959"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2227 17.2964V21.6964"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Wages;
